import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Typography } from '@material-ui/core';

import MultipleSelect from '~/components/Formik/FormFields/MultiSelectField';
import { IState } from '~/store';
import {
  getProfilesRequest,
  getGroupsRequest,
} from '~/store/modules/users/actions';

import useStyles from './styles';

interface Props {
  formField: {
    profiles: any;
    groups: any;
  };
}

const ProfileForm: React.FC<Props> = ({ formField }) => {
  const groups = useSelector((state: IState) => state.users.groups);
  const profiles = useSelector((state: IState) => state.users.profiles);

  const dispatch = useDispatch();

  const classes = useStyles();

  const { profiles: formProfiles, groups: formGroups } = formField;

  useEffect(() => {
    dispatch(getGroupsRequest());
    dispatch(getProfilesRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography variant="h6" gutterBottom className={classes.typography}>
        Perfil
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Selecione uma ou mais perfis que o usuário poderá ter:
      </Typography>
      <Grid item xs={12}>
        <MultipleSelect
          name={formProfiles.name}
          label={formProfiles.label}
          data={profiles.map((profile) => {
            return {
              value: profile.id,
              label: profile.name,
            };
          })}
          fullWidth
        />
      </Grid>

      <Typography variant="h6" gutterBottom className={classes.typography}>
        Função
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Selecione uma ou mais funções que o usuário poderá ter:
      </Typography>
      <Grid item xs={12}>
        <MultipleSelect
          name={formGroups.name}
          label={formGroups.label}
          data={groups.map((group) => {
            return {
              value: group.id,
              label: group.name,
            };
          })}
          fullWidth
        />
      </Grid>
    </>
  );
};

export default ProfileForm;
